import { createFileRoute } from '@tanstack/react-router';
import { PricingPage } from '@/components/marketing/pages/PricingPage';

export const Route = createFileRoute('/_marketing/pricing')({
  component: PricingPage,
});
